import PropTypes from 'prop-types'
import React, { MouseEvent } from 'react'
import { Route } from 'react-router-dom'
import { LocationDescriptorObject } from 'history'

export type RenderFunction = (props: any) => React.ReactNode

export interface Props {
  to: string | LocationDescriptorObject
  children: React.ReactElement | RenderFunction
  replace?: boolean
  onClick?: (event: MouseEvent, ...args: any[]) => void
} 

const LinkContainer: React.FC<Props> = ({ to, children, replace, onClick }) => {
  const locationObject: LocationDescriptorObject = typeof to === 'string' ? { pathname: to } : to

  if (typeof children === 'function') {
    return (
      <Route>
        {({ history }) => children({
          href: history.createHref(locationObject),
          onClick: (event, ...args) => {
            onClick && onClick(event, ...args)

            event.preventDefault()

            if (replace) {
              history.replace(locationObject)
            } else {
              history.push(locationObject)
            }
          }
        })}
      </Route>
    )
  } else if (React.isValidElement(children)) {
    return (
      <Route>
        {({ history }) => React.cloneElement(children, {
          href: history.createHref(
            typeof to === 'string' ? { pathname: to } : to
          ),
          onClick: (event, ...args) => {
            onClick && onClick(event, ...args)
            children.props.onClick && children.props.onClick(event, ...args)

            event.preventDefault()

            if (replace) {
              history.replace(locationObject)
            } else {
              history.push(locationObject)
            }
          }
        })}
      </Route>
    )
  }

  return null
}

export default LinkContainer
